/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    if (!window.Mojito || !Mojito.utils || !Mojito.Cookies) {
        console.error("Mojito utilities are required for this script to function.");
        return;
    }

    function treatment() {
        document.documentElement.classList.add('w4');
        var email = Mojito.Cookies.get('w4-email'),
            popupEmailInput,
            notThisEmailNode,
            newTriggerButton,
            submitBtn;

        var transformPopup = function () {
            var doc = document.querySelector('#BIS_frame').contentDocument,
                node;

            submitBtn = doc.querySelector('button[type="submit"]');
            if (!submitBtn) {
                window.setTimeout(transformPopup, 200);
                return;
            }

            popupEmailInput = doc.querySelector('#email_address');
            if (email) {
                popupEmailInput.value = email;
            }

            node = doc.querySelector('.modal-title + p');
            if (node) {
                node.innerHTML = 'Register your email below to receive a notification when this item is available again.';
            }

            node = doc.querySelector('.completed_message.alert-success');
            if (node) {
                node.innerHTML = 'Success. You\'ll be notified as soon as stock arrives.';
            }

            node = doc.querySelector('p.small-print');
            if (node) {
                node.style.display = 'none';
            }

            var waitForComplete = function () {
                if (submitBtn._isWaitingW4) {
                    return;
                }

                submitBtn._isWaitingW4 = true;
                Mojito.utils.waitUntil(function () {
                    var completed = jQuery(submitBtn).closest('.complete').length >= 1;
                    if (completed) {
                        return true;
                    }

                    var errorMessage = doc.querySelector('#message_holder').textContent;
                    return errorMessage.indexOf('You have already registered for a notification') >= 0;
                }, function () {
                    Mojito.Cookies.set('w4-email', jQuery.trim(popupEmailInput.value), { expires: 365 * 3 });
                    submitBtn._isWaitingW4 = false;

                    if (email) {
                        notThisEmailNode.style.display = 'none';
                        var successMessage = document.createElement('div');
                        successMessage.className = 'alert alert-success';
                        successMessage.innerHTML = 'Success. You\'ll be notified as soon as stock arrives.';
                        newTriggerButton.insertAdjacentElement('afterend', successMessage);

                        window.setTimeout(function () {
                            newTriggerButton.style.display = 'none';
                            successMessage.style.display = 'none';
                        }, 5000);
                    }
                }, 10000);
            };

            submitBtn.addEventListener('click', waitForComplete);
        };

        Mojito.utils.waitForElement('#BIS_frame', transformPopup);

        if (email) {
            w4TriggerButton.classList.add('has-email');
            newTriggerButton = document.createElement('button');
            newTriggerButton.type = 'button';
            newTriggerButton.className = 'btn btn--full new-trigger';
            newTriggerButton.innerHTML =
                'NOTIFY ME WHEN AVAILABLE' +
                '<span>(' + email + ')</span>';

            w4TriggerButton.insertAdjacentElement('afterend', newTriggerButton);
            newTriggerButton.addEventListener('click', function () {
                this.disabled = true;
                popupEmailInput.value = email;
                submitBtn.click();
            });

            notThisEmailNode = document.createElement('div');
            notThisEmailNode.className = 'not-this-email';
            notThisEmailNode.innerHTML = '<span>Not "' + email + '"?</span>';
            newTriggerButton.insertAdjacentElement('afterend', notThisEmailNode);
            notThisEmailNode.children[0].addEventListener('click', function () {
                popupEmailInput.value = '';
                w4TriggerButton.click();
            });
        }
    }

    function trigger() {
        if (!/\/products\//gi.test(location.pathname)) {
            return;
        }

        Mojito.utils.observeSelector('#BIS_trigger', function (bisButton) {
            if (bisButton.textContent === 'NOTIFY ME WHEN AVAILABLE' && bisButton.offsetParent) {
                window.w4TriggerButton = bisButton;
                var email = Mojito.Cookies.get('w4-email');
                if (email) {
                    treatment();
                } else {
                    bisButton.addEventListener('click', treatment);
                }
            }
        });
    }

    Mojito.utils.domReady(trigger);
})();
